/* import __COLOCATED_TEMPLATE__ from './open-loop-gain.hbs'; */
import Component from '@glimmer/component';

export default class OpenLoopGainError extends Component {
  get noninverting() {
    return (
      this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Amplifier' ||
      this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Buffer'
    );
  }
  get type() {
    if (
      this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Amplifier' ||
      this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Buffer'
    ) {
      return 'Non-Inverting';
    }
    return 'Inverting';
  }
}
